import React, { useState, useEffect } from 'react';

export default function CursorPagination(props) {
  const {
    nextCursor,
    prevCursor,
    onNext,
    onPrev,
    currentPage,
    setCurrentPage
  } = props;

  const [pageNumbers, setPageNumbers] = useState([]);
  const [totalPages, setTotalPages] = useState(1);

  // Simulate page numbers for display (since cursor pagination doesn't have exact page numbers)
  useEffect(() => {
    // This is a simplified approach to show page progression
    // In a real implementation, you might track page count differently
    const newPageNumbers = [];

    if (currentPage === 1) {
      // First page
      newPageNumbers.push(1);
      if (nextCursor) newPageNumbers.push(2);
      if (nextCursor) newPageNumbers.push(3);
    } else {
      // Subsequent pages
      newPageNumbers.push(currentPage - 1);
      newPageNumbers.push(currentPage);
      if (nextCursor) newPageNumbers.push(currentPage + 1);
    }

    setPageNumbers(newPageNumbers);
    setTotalPages(nextCursor ? currentPage + 1 : currentPage);
  }, [currentPage, nextCursor]);

  const handleNext = () => {
    if (nextCursor) {
      setCurrentPage(currentPage + 1);
      onNext();
    }
  };

  const handlePrevious = () => {
    if (prevCursor) {
      setCurrentPage(currentPage - 1);
      onPrev();
    }
  };

  const handlePageClick = (page) => {
    if (currentPage < page) {
      onNext();
    } else {
      onPrev();
    }
    // This is a simplified implementation
    // In a real app, you might need to track cursors for each page
    setCurrentPage(page);
  };

  return (
    <div className="pagination">
      <div className="flex items-center justify-center space-x-1 mt-6 p-2">
        <button
          onClick={handlePrevious}
          disabled={!prevCursor}
          className={`px-3 py-2 rounded-md border ${!prevCursor
            ? "bg-gray-200 text-gray-400 cursor-not-allowed"
            : "hover:bg-gray-100"
            }`}
        >
          Previous
        </button>

        {pageNumbers.map((page) => (
          <button
            key={page}
            onClick={() => handlePageClick(page)}
            className={`border px-3 py-2 rounded-md ${page === currentPage ? "bg-[#0c2f55] text-white" : "hover:bg-gray-100"
              }`}
          >
            {page}
          </button>
        ))}

        <button
          onClick={handleNext}
          disabled={!nextCursor}
          className={`px-3 py-2 rounded-md border ${!nextCursor
            ? "bg-gray-200 text-gray-400 cursor-not-allowed"
            : "hover:bg-gray-100"
            }`}
        >
          Next
        </button>
      </div>
    </div>
  );
}